export const defaultMemberSignInFormData = {
    username: '',
    email: '',
    password: '',
    captcha: undefined,
    remember: false
};
